module.exports = __webpack_public_path__ + "img/user.cd0e8ee6.png";